module.exports = __webpack_public_path__ + "img/checkbox-white.47f3b28.svg";